import Button from 'components/Button';

interface ReceivedPartnerRequest {
  id: string;
  senderUserProfile?: {
    fullName?: string | null;
    preferredName?: string | null;
  } | null;
}

interface ReceivedPartnerRequestCardProps {
  request: ReceivedPartnerRequest;
  isLoading?: boolean;
  onAccept: (invitationId: string) => void;
  onDeny: (invitationId: string) => void;
  rating?: string | null;
}

export default function ReceivedPartnerRequestCard({
  request,
  isLoading,
  onAccept,
  onDeny,
  rating,
}: ReceivedPartnerRequestCardProps) {
  const senderName =
    request.senderUserProfile?.fullName || request.senderUserProfile?.preferredName || 'A player';

  return (
    <div className="mt-4 rounded-2xl bg-[#F5F3FF] p-4">
      <div className="mb-3 flex flex-col items-center gap-2">
        {/* Icon placeholder — replace with actual asset when available */}
        <img
          src="/images/tournaments/partner-icon.png"
          className="flex h-10 w-10 items-center justify-center rounded-full bg-color-bg-lightmode-tertiary dark:bg-color-bg-darkmode-tertiary"
        />
        <p className="typography-product-subheading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          Partner request
        </p>
      </div>
      <div className="mb-4 flex items-center justify-center gap-2">
        <span className="typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          {senderName}
        </span>
        {rating && (
          <span className="typography-product-body text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary">
            (VAIR {rating})
          </span>
        )}
      </div>
      <div className="flex gap-3">
        <Button
          type="button"
          variant="secondary"
          size="md"
          className="bg-transparent"
          onClick={() => onDeny(request.id)}
          disabled={isLoading}
        >
          Deny
        </Button>
        <Button
          type="button"
          variant="primary"
          size="md"
          onClick={() => onAccept(request.id)}
          loading={isLoading}
        >
          Accept
        </Button>
      </div>
    </div>
  );
}
